export default [
  {
    hidden: true,
    path: '/login',
    redirect: {
      path:"/map/index",
      query: {
        isLogin: true
      },
    },
    component: () => import(/* webpackChunkName: "map" */ "@/views/map"),
    name: "map",
    meta: { title: "Map", icon: "map-v2", keepName: 'tripPlanning', keepAlive: true }
  },
  {
    hidden: true,
    path: '/login/empty',
    name: "Login",
    component: () => import(/* webpackChunkName: "login-dashboard" */ "@/views/login-v2/login"),
  },

  {
    hidden: true,
    path: '/login/forget',
    name: 'LoginForget',
    component: () => import(/* webpackChunkName: "login-forget" */ "@/views/login-v2/forget.vue"),
  },
  {
    hidden: true,
    path: '/login/register',
    name: "LoginRegister",
    component: () => import(/* webpackChunkName: "login-register" */ "@/views/login/views/register"),
  },
]